import { render, staticRenderFns } from "./myvideo.vue?vue&type=template&id=e07ba1e0&scoped=true&"
import script from "./myvideo.vue?vue&type=script&lang=js&"
export * from "./myvideo.vue?vue&type=script&lang=js&"
import style0 from "./myvideo.vue?vue&type=style&index=0&id=e07ba1e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07ba1e0",
  null
  
)

export default component.exports